module.exports = __webpack_public_path__ + "static/media/storeImage.65f0f848.svg";